import React, {useEffect, useState} from "react";
import TopBreadcrumbs from "../Settings/Surcharge/TopBreadcrumbs";
import {createNetworkIntegrationBreadcrumb, editNetworkIntegrationBreadcrumb} from "../../common/data/parties";
import {Button, Card, CardBody, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import Select from "react-select";
import {useLocation, useNavigate} from "react-router-dom";
import FileUpload from "../Settings/FileUpload";
import {FieldArray, Formik, FormikProvider, useFormik} from "formik";
import * as Yup from "yup";
import {useDispatch, useSelector} from "react-redux";
import {accessMarketPlaceRate} from "../../store/layout/actions";
import {getMarketPlaceRate} from "../../components/Common/CommonLogic";
import {postIntegrationConfig} from "../../store/Settings/actions";
import {GET_NETWORK_CHANNEL_TYPE, NETWORK_INTEGRATION_INIT} from "../../store/Settings/actiontype";

const CreateNetworkIntegrations = () => {
    const navigateState = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [editData, setEditData] = useState({});
    const [id, setId] = useState();
    const { getAllChannelTypes, networkIntegrationsPostSuccess } = useSelector((state) => state?.settings);

    useEffect(() => {
        dispatch({ type: NETWORK_INTEGRATION_INIT });
        dispatch({ type: GET_NETWORK_CHANNEL_TYPE });
        if (navigateState?.state?.data !== undefined) {
            setEditData(navigateState?.state?.data);
            setId(navigateState?.state?.id);
            //console.log(navigateState?.state?.data, "data");
            //console.log(navigateState?.state?.id, "id");
        }
    }, []);

    useEffect(() => {
        console.log(getAllChannelTypes, "getAllChannelTypes")
        const selectedChannelType = getAllChannelTypes?.find(
            opt => String(opt.value) === String(editData?.channelTypeId ?? "")
        ) || null;
        //console.log(selectedChannelType, "selectedChannelType");
        networkIntegrationFormik.setFieldValue("channelTypeId", selectedChannelType);
    }, [getAllChannelTypes]);

    useEffect(() => {
        if (networkIntegrationsPostSuccess === true) {
            navigate(-1);
        }
    }, [networkIntegrationsPostSuccess]);

    const onUploadChange = (file) => {
        networkIntegrationFormik.setFieldValue("image", file);
        networkIntegrationFormik.setTouched({ image: true });
    };

    const validationSchema = Yup.object({
        channelTypeId: Yup.mixed().required("App Type is required"),
        appName: Yup.string().required("App Name is required"),
        appDescription: Yup.string().notRequired(),
        appChannelIntegrationFields: Yup.array().of(
            Yup.object().shape({
                fieldName: Yup.string().required("Field name is required"),
            })
        ),
        image: Yup.mixed().notRequired(),
    });

    const networkIntegrationFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            channelTypeId: null,
            appName: editData.appName || "",
            appDescription: editData.appDescription || "",
            appChannelIntegrationFields: editData.appChannelIntegrationFields || [{ fieldName: "" }],
            image: editData ? editData?.logo : editData?.logoPath || "",
        },
        validationSchema,
        onSubmit: ({ image, ...value }) => {

            const appChannelPayload = {
                channelTypeId: value.channelTypeId?.value || null,
                appName: value.appName,
                appDescription: value.appDescription,
                appChannelIntegrationFields: value.appChannelIntegrationFields,
                id: id ? id : null,
                version : editData ? editData.version : null,
            };

            const formData = new FormData();

            // ✅ Append image only if it exists
            if (image) {
                formData.append("file", image);
            }

            // ✅ Convert JSON to Blob and append
            const jsonBlob = new Blob([JSON.stringify(appChannelPayload)], { type: "application/json" });
            formData.append("appChannel", jsonBlob);

            dispatch(postIntegrationConfig(formData));
        },
    });

    return(
        <>
            <div className="page-content settings_wrapper">
                <TopBreadcrumbs breadcrumbs={id ? editNetworkIntegrationBreadcrumb : createNetworkIntegrationBreadcrumb } />
                <Container fluid>
                    <FormikProvider value={networkIntegrationFormik}>
                        <Form onSubmit={networkIntegrationFormik.handleSubmit}>
                            <Row className="mt-4">
                                {/* Left Side: Form */}
                                <Col md={7}>
                                    {/* APP Type */}
                                    <FormGroup>
                                        <Label className="fw-bold">Select APP Type</Label>
                                        <Select
                                            options={getAllChannelTypes}
                                            value={networkIntegrationFormik.values.channelTypeId}
                                            placeholder={"Select Channel Types...."}
                                            onChange={(option) => networkIntegrationFormik.setFieldValue("channelTypeId", option)}
                                        />
                                        {networkIntegrationFormik.errors.channelTypeId && <div className="text-danger">{networkIntegrationFormik.errors.channelTypeId}</div>}
                                    </FormGroup>

                                    {/* APP Name */}
                                    <FormGroup>
                                        <Label className="fw-bold">APP Name</Label>
                                        <Input
                                            type="text"
                                            name="appName"
                                            value={networkIntegrationFormik.values.appName}
                                            onChange={networkIntegrationFormik.handleChange}
                                            onBlur={networkIntegrationFormik.handleBlur}
                                        />
                                        {networkIntegrationFormik.touched.appName && networkIntegrationFormik.errors.appName && (
                                            <div className="text-danger">{networkIntegrationFormik.errors.appName}</div>
                                        )}
                                    </FormGroup>

                                    {/* Dynamic Fields */}
                                    <FormGroup>
                                        <Label className="fw-bold">Add Field Names</Label>
                                        <FieldArray name="appChannelIntegrationFields">
                                            {({ push, remove }) => (
                                                <>
                                                    {networkIntegrationFormik.values.appChannelIntegrationFields.map((field, index) => (
                                                        <Row key={index} className="mb-2 align-items-center">
                                                            <Col md={10}>
                                                                <Input
                                                                    type="text"
                                                                    name={`appChannelIntegrationFields[${index}].fieldName`}
                                                                    value={field.fieldName}
                                                                    onChange={networkIntegrationFormik.handleChange}
                                                                    onBlur={networkIntegrationFormik.handleBlur}
                                                                />
                                                                {networkIntegrationFormik.touched.appChannelIntegrationFields?.[index]?.fieldName
                                                                    && networkIntegrationFormik.errors.appChannelIntegrationFields?.[index]?.fieldName && (
                                                                        <div className="text-danger">
                                                                            {networkIntegrationFormik.errors.appChannelIntegrationFields[index].fieldName}
                                                                        </div>
                                                                )}
                                                            </Col>
                                                            <Col md={2} className="text-start">
                                                                <Button
                                                                    color={index === networkIntegrationFormik.values.appChannelIntegrationFields.length - 1 ? "primary" : "danger"}
                                                                    type="button"
                                                                    onClick={() => (index === networkIntegrationFormik.values.appChannelIntegrationFields.length - 1 ? push({ fieldName: "" }) : remove(index))}
                                                                    size="md"
                                                                >
                                                                    {index === networkIntegrationFormik.values.appChannelIntegrationFields.length - 1 ? "+" : "-"}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                </>
                                            )}
                                        </FieldArray>
                                    </FormGroup>

                                    {/* APP Description */}
                                    <FormGroup>
                                        <Label className="fw-bold">APP Description</Label>
                                        <Input
                                            type="textarea"
                                            name="appDescription"
                                            value={networkIntegrationFormik.values.appDescription}
                                            onChange={networkIntegrationFormik.handleChange}
                                            onBlur={networkIntegrationFormik.handleBlur}
                                        />
                                        {networkIntegrationFormik.touched.appDescription && networkIntegrationFormik.errors.appDescription && (
                                            <div className="text-danger">{networkIntegrationFormik.errors.appDescription}</div>
                                        )}
                                    </FormGroup>

                                    {/* Buttons */}
                                    <div className="d-flex justify-content-center gap-2 mt-4">
                                        <Button type="button" color="danger">
                                            Cancel
                                        </Button>
                                        <Button type="submit" color="success">
                                            Save
                                        </Button>
                                    </div>
                                </Col>

                                {/* Right Side: Image Upload */}
                                <Col md={5} className="d-flex justify-content-center align-items-top">
                                    <div
                                        style={{
                                            width: "350px",
                                            height: "250px",
                                            background: "#e9ecef",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        <FileUpload
                                            iconName="img"
                                            name="image"
                                            onUpload={onUploadChange}
                                            src={editData ? editData?.logo : editData?.logo || ""}
                                            className="form-control"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </FormikProvider>
                </Container>
            </div>
        </>
    );
}

export default CreateNetworkIntegrations
